'use client';

import React from 'react';
import Link from 'next/link';

interface AccordionItemProps {
  number: string;
  title: string;
  link: string;
}

const AccordionItem: React.FC<AccordionItemProps> = ({ number, title }) => {
  // {link;}
  return (
    <div className="border-b border-[#E5E1D5]/40 py-[5px] md:py-1 hover:border-[#E5E1D5] cursor-pointer relative z-10 transition-all">
      <Link
        href="/process"
        className="flex justify-between items-center text-[16px] font-light text-[#e5e1d5]"
      >
        {/* <div className="flex justify-between items-center text-[16px] font-light text-[#e5e1d5]"> */}
        <div className="flex items-center">
          <span className=" w-16">{number}</span>
          <span>{title}</span>
        </div>
        <span className="explore-text">Explore</span>
        {/* </div> */}
      </Link>
    </div>
  );
};

interface AccordionProps {
  items: AccordionItemProps[];
}

const Accordion: React.FC<AccordionProps> = ({ items }) => {
  return (
    <div className="w-full">
      {items.map((item, index) => (
        <AccordionItem key={index} number={item.number} title={item.title} link={item.link} />
      ))}
    </div>
  );
};

export default Accordion;
